// Crawlable homepage copy for the initial HTML of `/` (#775).
// Pokémon-only links (#695 / #774). Other client routes use spa.html,
// produced by stripHomepageSeo, so this block is not the body of every URL (#743).

const GENERIC_TITLE = 'HOLIC [ホリック] • 新トレカ売買サイト'

const GENERIC_DESCRIPTION = 'あなたのポケモンカードゲームのための一つのショップ！あなたのカードを他のプレイヤーに販売するためにあなたのショップを設定します！'

const HOMEPAGE_TITLE = 'ポケモンカードの販売・相場 | HOLIC（ホリック）'

const HOMEPAGE_DESCRIPTION = 'HOLIC（ホリック）は、日本語版ポケモンカードのマーケットプレイスです。旧裏や1st Edition、キラ、拡張パックの販売中リストと状態ガイドを掲載しています。'

const SITE_URL = 'https://holic.net/'

const homepageDocument = {
  h1: 'ポケモンカードのマーケットプレイス',
  lead: '出品者の価格で探す。買取価格の一覧ではなく、販売中のカードをそのまま比べられます。',
  intro: [
    '売りたい人と買いたい人の出品が並ぶマーケットプレイスです。買取価格の一覧ではなく、出品者ごとの販売価格でカードを探せます。',
    '旧裏の初代シリーズからスカーレット＆バイオレットの拡張パックまで、セットの一覧と、いま販売中の出品を同じ場所からたどれます。',
  ],
  trustHeading: 'HOLICでカードを探す理由',
  shop: {
    hubLabel: '人気の探し方',
    marketLabel: 'おすすめ',
    primaryLabel: '販売中を見る',
    secondaryLabel: 'カードを探す',
    secondaryHref: '/categories/1',
    tertiaryLabel: '状態ガイド',
  },
  trust: [
    {
      title: 'ポケモンカードから探す',
      body: '時代、拡張パック、販売中の一覧へ、このページから直接移動できます。',
      home: false,
    },
    {
      title: '販売価格が見える',
      body: '出品中のカードは、出品者が設定した価格のまま並びます。',
    },
    {
      title: '状態の目安がある',
      body: 'キズ、白かけ、PSAなどの鑑定品の違いを状態ガイドにまとめています。',
    },
    {
      title: '販売中から探す',
      body: 'セットのページから、いま出ているカードの一覧を開けます。',
    },
  ],
  groups: [
    {
      id: 'hubs',
      heading: '時代・テーマから探す',
      links: [
        { href: '/categories/2', label: '旧裏（初代シリーズ）', chip: '旧裏' },
        { href: '/categories/5', label: '1st Edition（初版・マークなし）', chip: '1st Edition' },
        { href: '/categories/1?view=listings&rarities=26', label: 'キラ（ホロレア）', chip: 'キラ' },
        { href: '/categories/1?view=listings&grader=PSA', label: 'PSA鑑定品', chip: 'PSA' },
      ],
    },
    {
      id: 'sets',
      heading: '拡張パックから探す',
      links: [
        { href: '/categories/4089', label: 'ポケモンカード151' },
        { href: '/categories/3710', label: '拡張パック スカーレットex' },
        { href: '/categories/3711', label: '拡張パック バイオレットex' },
        { href: '/categories/4027', label: '拡張パック クレイバースト' },
        { href: '/categories/4026', label: '拡張パック スノーハザード' },
        { href: '/categories/3371', label: 'ハイクラスパック VSTARユニバース' },
        { href: '/categories/3', label: '第1弾拡張パック' },
        { href: '/categories/34', label: 'ポケモンジャングル' },
      ],
    },
    {
      id: 'forSale',
      heading: '販売中のカード',
      links: [
        { href: '/categories/1?view=listings&stocks=for_sale', label: '販売中のカード一覧', chip: '販売中' },
      ],
    },
    {
      id: 'guide',
      heading: '状態と運営',
      links: [
        { href: '/about/condition', label: 'カードの状態ガイド' },
        { href: '/about/company', label: '運営会社' },
        { href: '/about/tokushouhou', label: '特定商取引法に基づく表記' },
      ],
    },
  ],
}

function escapeHtml (value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function organizationJsonLd () {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'HOLIC',
    alternateName: 'ホリック',
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: 'https://holic.net/favicons/android-icon-192x192.png',
    },
    description: HOMEPAGE_DESCRIPTION,
    email: 'support@holic.net',
    telephone: '+81-50-7119-7640',
    sameAs: ['https://twitter.com/holicapp'],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '新宿1-36-2 新宿第七葉山ビル3階',
      addressLocality: '新宿区',
      addressRegion: '東京都',
      postalCode: '160-0022',
      addressCountry: 'JP',
    },
    parentOrganization: {
      '@type': 'Organization',
      name: 'inkr株式会社',
    },
  }
}

function organizationJsonLdText () {
  return JSON.stringify(organizationJsonLd(), null, 2).replace(/</g, '\\u003c')
}

function anchor (href, label, className) {
  const cls = className ? ' class="' + escapeHtml(className) + '"' : ''
  return '<a' + cls + ' href="' + escapeHtml(href) + '">' + escapeHtml(label) + '</a>'
}

function groupById (id) {
  for (let i = 0; i < homepageDocument.groups.length; i++) {
    if (homepageDocument.groups[i].id === id) return homepageDocument.groups[i]
  }
  throw new Error('Missing homepage group: ' + id)
}

function renderHomepageBodyHtml () {
  const doc = homepageDocument
  const hubs = groupById('hubs')
  const sets = groupById('sets')
  const forSale = groupById('forSale')
  const guide = groupById('guide')
  const primary = forSale.links[0]
  const condition = guide.links.filter(function (link) { return link.href === '/about/condition' })[0] || guide.links[0]
  const chips = hubs.links.concat([primary])
  const visibleTrust = doc.trust.filter(function (point) { return point.home !== false })

  const chipItems = chips.map(function (link) {
    return '      <li>' + anchor(link.href, link.chip || link.label) + '</li>'
  }).join('\n')

  const entryItems = sets.links.slice(0, 6).map(function (link) {
    return '      <li>' + anchor(link.href, link.label, 'home-seo-entry') + '</li>'
  }).join('\n')

  const setItems = sets.links.map(function (link) {
    return '      <li>' + anchor(link.href, link.label) + '</li>'
  }).join('\n')

  const trustItems = visibleTrust.map(function (point) {
    return '      <li><strong>' + escapeHtml(point.title) + '</strong> ' + escapeHtml(point.body) + '</li>'
  }).join('\n')

  const guideItems = guide.links.map(function (link) {
    return '        <li>' + anchor(link.href, link.label) + '</li>'
  }).join('\n')

  const intro = doc.intro.map(function (paragraph) {
    return '    <p>' + escapeHtml(paragraph) + '</p>'
  }).join('\n')

  return [
    '<section id="home-seo" lang="ja" class="home-seo">',
    '  <div class="home-seo-hero">',
    '    <h1>' + escapeHtml(doc.h1) + '</h1>',
    '    <p class="home-seo-lead">' + escapeHtml(doc.lead) + '</p>',
    '    <div class="home-seo-ctas">',
    '      ' + anchor(primary.href, doc.shop.primaryLabel, 'home-seo-cta home-seo-cta-primary'),
    '      ' + anchor(doc.shop.secondaryHref, doc.shop.secondaryLabel, 'home-seo-cta home-seo-cta-secondary'),
    '      ' + anchor(condition.href, doc.shop.tertiaryLabel, 'home-seo-cta home-seo-cta-tertiary'),
    '    </div>',
    '  </div>',
    '  <div class="home-seo-market" aria-label="' + escapeHtml(doc.shop.marketLabel) + '">',
    '    <p class="home-seo-kicker">' + escapeHtml(doc.shop.marketLabel) + '</p>',
    '    <ul class="home-seo-entries">',
    entryItems,
    '    </ul>',
    '  </div>',
    '  <nav class="home-seo-hubs" aria-label="' + escapeHtml(doc.shop.hubLabel) + '">',
    '    <p class="home-seo-kicker">' + escapeHtml(doc.shop.hubLabel) + '</p>',
    '    <ul class="home-seo-chips">',
    chipItems,
    '    </ul>',
    '  </nav>',
    '  <nav class="home-seo-sets" aria-label="' + escapeHtml(sets.heading) + '">',
    '    <h2>' + escapeHtml(sets.heading) + '</h2>',
    '    <ul class="home-seo-tiles">',
    setItems,
    '    </ul>',
    '  </nav>',
    '  <div class="home-seo-below">',
    intro,
    '    <ul class="home-seo-trust">',
    trustItems,
    '    </ul>',
    '    <nav class="home-seo-guides" aria-label="' + escapeHtml(guide.heading) + '">',
    '      <ul class="home-seo-legal">',
    guideItems,
    '      </ul>',
    '    </nav>',
    '  </div>',
    '</section>',
  ].join('\n')
}

function renderExtraHead () {
  return [
    '    <link id="home-canonical" rel="canonical" href="' + SITE_URL + '" />',
    '    <script id="home-organization-jsonld" type="application/ld+json">',
    organizationJsonLdText(),
    '    </script>',
  ].join('\n')
}

function block (name, inner) {
  const body = inner === '' ? '' : '\n' + inner + '\n    '
  return '<!-- ' + name + ' -->' + body + '<!-- /' + name + ' -->'
}

function replaceBlock (html, name, inner) {
  const pattern = new RegExp('<!-- ' + name + ' -->[\\s\\S]*?<!-- /' + name + ' -->')

  if (!pattern.test(html)) {
    throw new Error('Missing homepage SEO marker: ' + name)
  }

  return html.replace(pattern, block(name, inner))
}

function applyHomepageSeo (html) {
  let next = replaceBlock(html, 'home-seo-title', '    <title>' + escapeHtml(HOMEPAGE_TITLE) + '</title>')
  next = replaceBlock(next, 'home-seo-description', '    <meta name="description" content="' + escapeHtml(HOMEPAGE_DESCRIPTION) + '" />')
  next = replaceBlock(next, 'home-seo-extra-head', renderExtraHead())
  next = replaceBlock(next, 'home-seo-body', '    ' + renderHomepageBodyHtml().replace(/\n/g, '\n    '))
  return next
}

function stripHomepageSeo (html) {
  // CRA minifies index.html and drops the marker comments, so match the
  // elements themselves. The same replacements work on the unminified source.
  let next = html.replace(/<script id="home-organization-jsonld"[\s\S]*?<\/script>/, '')
  next = next.replace(/<link id="home-canonical"[^>]*>/, '')
  next = next.replace(/<section id="home-seo"[\s\S]*?<\/section>/, '')
  next = next.replace(/<title>[\s\S]*?<\/title>/, '<title>' + escapeHtml(GENERIC_TITLE) + '</title>')
  next = next.replace(/<meta name="description" content="[\s\S]*?"\s*\/?>/, '<meta name="description" content="' + escapeHtml(GENERIC_DESCRIPTION) + '" />')
  return next
}

module.exports = {
  GENERIC_DESCRIPTION,
  GENERIC_TITLE,
  HOMEPAGE_DESCRIPTION,
  HOMEPAGE_TITLE,
  SITE_URL,
  applyHomepageSeo,
  homepageDocument,
  organizationJsonLd,
  organizationJsonLdText,
  renderHomepageBodyHtml,
  stripHomepageSeo,
}
